import styled from 'styled-components';

const StyledChevron = styled.img`
    transition: transform 0.2s ease-in; 
    -ms-transform: rotate(${props => props.active ? "180deg" : "0deg"});
    transform: rotate(${props => props.active ? "180deg" : "0deg"});
`;

export default StyledChevron;